import React, { useCallback, useEffect } from "react";
import LineDayChart from "./line-day-chart";
import DatesRange from "../dates-range";
import store from "../../store";
import { observer } from "mobx-react";
import graphsService from "./graph-service";
import PositiveNegativeBar from "./positive-negative-bar";
import StackedArea from "./stacked-area-chart";
import StackedBar from "./stacked-bar";

function KpiPerDayGraphs() {

  useEffect(() => {
    fetchGlobalKpisPerDay();
  }, []);

  const fetchGlobalKpisPerDay = useCallback(async () => {
    await graphsService.fetchAllDateSlideListeners(store.start_date, store.day_before_end_date);
  }, []);

  return (
    <div>
      <div>
        <DatesRange />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-1 2xl:grid-cols-1 gap-2 p-4 text-center">
        {
          store.all_time_revenue_segments_data.length > 0 ?
            (<StackedArea entities={store.all_time_revenue_segments_data} group_by={'day'}
              data_key={[
                { key: 'total_other_revenue', fill: '#f2cc8f' },
                { key: 'total_control_revenue', fill: '#e07a5f' },
                { key: 'total_twik_revenue', fill: '#81b29a' },
                { key: 'increased_revenue', fill: '#81b29a' }
              ]} />
            ) : <></>
        }
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-2 gap-2 p-4 text-center">
        {
          store.revenue_segments_data.length > 0 ?
            (<StackedArea entities={store.revenue_segments_data} group_by={'day'}
              data_key={[
                { key: 'nontwik_revenue', fill: '#f2cc8f' },
                { key: 'control_revenue', fill: '#e07a5f' },
                { key: 'twik_revenue', fill: '#81b29a' },
                { key: 'increased_revenue', fill: '#81b29a' }
              ]} />
            ) : <></>
        }
        {
          store.increased_revenue_data.length > 0 ?
            (<PositiveNegativeBar title='increased_revenue' entities={store.increased_revenue_data} group_by={'day'} data_key={'increased_revenue'} />
            ) : <></>
        }
      </div>
      <div className="grid grid-cols-2 gap-2 p-4 text-center">
        {
          store.wins_count_control_and_twik_no_cache.length > 0 ?
            (<StackedBar title='NO CACHE: domains win counts, more than 15 twik AND control deals per day'
              entities={store.wins_count_control_and_twik_no_cache} group_by={'day'} bars_list={[
                { name: 'other_win', fill: '#f2cc8f' },
                { name: 'control_win', fill: '#e07a5f' },
                { name: 'twik_win', fill: '#81b29a' }
              ]} />)
            :
            <></>
        }
        {
          store.wins_count_control_and_twik_no_cache.length > 0 ?
            (<PositiveNegativeBar title='NO CACHE: winning percent, more than 15 twik AND control deals per day'
              entities={store.wins_count_control_and_twik_no_cache} group_by={'day'} data_key={'twik_winning_percent'} />
            ) : <></>
        }
      </div>
      <div className="grid grid-cols-2 gap-2 p-4 text-center">
        {
          store.wins_count_twik_no_cache.length > 0 ?
            (<StackedBar title='NO CACHE: domains win counts, more than 15 twik deals per day'
              entities={store.wins_count_twik_no_cache} group_by={'day'} bars_list={[
                { name: 'other_win', fill: '#f2cc8f' },
                { name: 'control_win', fill: '#e07a5f' },
                { name: 'twik_win', fill: '#81b29a' }
              ]} />)
            :
            <></>
        }
        {
          store.wins_count_twik_no_cache.length > 0 ?
            (<PositiveNegativeBar title='NO CACHE: winning percent, more than 15 twik deals per day'
              entities={store.wins_count_twik_no_cache} group_by={'day'} data_key={'twik_winning_percent'} />
            ) : <></>
        }
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 gap-2 p-4 text-center">
        {/* {
          store.wins_count_control_and_twik.length > 0 ?
            (<StackedBar title='domains win counts, more than 15 twik AND control deals per day' entities={store.wins_count_control_and_twik} group_by={'day'} bars_list={[
              {name: 'other_win', fill: '#f2cc8f'},
              {name: 'control_win', fill: '#e07a5f'},
              {name: 'twik_win', fill: '#81b29a'}
            ]}/>)
            :
            <></>
        }
        {
          store.wins_count_twik.length > 0 ?
            (<StackedBar title='domains win counts, more than 15 twik deals per day' entities={store.wins_count_twik} group_by={'day'} bars_list={[
              {name: 'other_win', fill: '#f2cc8f'},
              {name: 'control_win', fill: '#e07a5f'},
              {name: 'twik_win', fill: '#81b29a'}
            ]}/>)
            :
            <></>
        } */}
        {
          store.fp_overlaps.length > 0 ?
            (
              <>
                <StackedBar title='Users with no history' entities={store.fp_overlaps} group_by={'day'} bars_list={[
                  { name: 'users_no_history_mobile_percent', fill: '#f2cc8f' },
                  { name: 'users_no_history_desktop_percent', fill: '#81b29a' },
                ]} />
                <StackedBar title='Sessions with no history' entities={store.fp_overlaps} group_by={'day'} bars_list={[
                  { name: 'sessions_no_history_mobile_percent', fill: '#f2cc8f' },
                  { name: 'sessions_no_history_desktop_percent', fill: '#81b29a' },
                ]} />
                <StackedBar title='Overlapped fingerprints' entities={store.fp_overlaps} group_by={'day'} bars_list={[
                  { name: 'fingerprint_overlapped_mobile_percent', fill: '#f2cc8f' },
                  { name: 'fingerprint_overlapped_desktop_percent', fill: '#81b29a' },
                ]} />
              </>
            )
            :
            <></>
        }
        {/* {
          store.wins_count_control_and_twik.length > 0 ?
            (<PositiveNegativeBar title='winning percent, more than 15 twik AND control deals per day' entities={store.wins_count_control_and_twik} group_by={'day'} data_key={'twik_winning_percent'}/>
            ) : <></>
        }
        {
          store.wins_count_twik.length > 0 ?
            (<PositiveNegativeBar title='winning percent, more than 15 twik deals per day' entities={store.wins_count_twik} group_by={'day'} data_key={'twik_winning_percent'}/>
            ) : <></>
        } */}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 gap-2 p-4 text-center">
        {
          store.fp_survivability.with_ts.length > 0 ?
            (<StackedBar title='fp survivability in minutes, WITH time stamp' entities={store.fp_survivability.with_ts} group_by={'day'} bars_list={[
              { name: 'avg_minutes', fill: '#f2cc8f', label: 'time' },
              { name: 'avg_hours', fill: '#81b29a', label: 'time' },
            ]} />)
            :
            <></>
        }
        {
          store.fp_survivability.no_ts.length > 0 ?
            (<StackedBar title='fp survivability in minutes, NO time stamp' entities={store.fp_survivability.no_ts} group_by={'day'} bars_list={[
              { name: 'avg_minutes', fill: '#f2cc8f', label: 'time' },
              { name: 'avg_hours', fill: '#81b29a', label: 'time' },
            ]} />)
            :
            <></>
        }
      </div>
      {/* <div className="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 gap-2 p-4 text-center">
        {
          store.entities_graph_data.length > 0 ?
            Object.keys(store.entities_graph_data[0]).sort().map((kpi, index) => {
              return (<LineDayChart
                group_by={'day'}
                app_type={'all'}
                graph_type='single_value'
                key={kpi} entities={store.entities_graph_data}
                label={kpi} data_key={kpi} index={index}/>);
            }) : (<div className="h-screen text-white text-center">Loading</div>)
        }
      </div> */}
      {/* <hr/> */}
      {/* <div className="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 gap-2 p-4 text-center">
        {
          Object.keys(store.twik_control_segments).length > 0 ?
            Object.keys(store.twik_control_segments).map((kpi, index) => {
              return (<LineDayChart graph_type='twik_control_segments'
                                    group_by={'day'}
                                    app_type={'all'}
                                    key={kpi}
                                    entities={store.twik_control_segments[kpi]}
                                    label={kpi}
                                    data_key={kpi}
                                    index={index}/>);
            }) : (<div className="h-screen text-white text-center">Loading</div>)
        }
      </div> */}
      <div className="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 gap-2 p-4 text-center">
        <LineDayChart group_by={'day'} app_type={'all'} graph_type='none' key={'total_deals_source'} entities={store.checkouts} label={'Deals'} data_key={'total_deals_source'} />
        <LineDayChart group_by={'day'} app_type={'all'} graph_type='none' key={'total_revenue_source'} entities={store.checkouts} label={'Revenue'} data_key={'total_revenue_source'} />
        <LineDayChart group_by={'day'} app_type={'all'} graph_type='twik_control_segments' key={'rps'} entities={store.rps} label={'Rps'} data_key={'rps'} />
      </div>
      <hr />
      <div className="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 gap-2 p-4 text-center">
        <LineDayChart group_by={'day'} app_type={'all'} graph_type='none' key={'total_sessions_source'} entities={store.events} label={'Sessions'} data_key={'total_sessions_source'} />
        <LineDayChart group_by={'day'} app_type={'all'} graph_type='none' key={'total_users_source'} entities={store.events} label={'Users'} data_key={'total_users_source'} />
        <LineDayChart group_by={'day'} app_type={'all'} graph_type='none' key={'total_views_source'} entities={store.events} label={'Views'} data_key={'total_views_source'} />
        <LineDayChart group_by={'day'} app_type={'all'} graph_type='none' key={'total_atws_source'} entities={store.events} label={'Add to wishlist'} data_key={'total_atws_source'} />
        <LineDayChart group_by={'day'} app_type={'all'} graph_type='none' key={'total_atcs_source'} entities={store.events} label={'Add to cart'} data_key={'total_atcs_source'} />
        <LineDayChart group_by={'day'} app_type={'all'} graph_type='none' key={'total_clicks_source'} entities={store.events} label={'Clicks'} data_key={'total_clicks_source'} />
        <LineDayChart group_by={'day'} app_type={'all'} graph_type='none' key={'total_leads_source'} entities={store.events} label={'Leads'} data_key={'total_leads_source'} />
        <LineDayChart group_by={'day'} app_type={'all'} graph_type='none' key={'total_logins_source'} entities={store.events} label={'Logins'} data_key={'total_logins_source'} />
        <LineDayChart group_by={'day'} app_type={'all'} graph_type='none' key={'total_newsletters_source'} entities={store.events} label={'Newsletters'} data_key={'total_newsletters_source'} />
        <LineDayChart group_by={'day'} app_type={'all'} graph_type='none' key={'total_submissions_source'} entities={store.events} label={'Submissions'} data_key={'total_submissions_source'} />
      </div>
      <hr />

    </div>
  );
}

export default observer(KpiPerDayGraphs);
